import { LockClosedIcon } from "@heroicons/react/24/outline";
import { useTranslations } from "use-intl";

export function ThreadClosedBanner({ closed }: { closed?: boolean }) {
  const t = useTranslations("thread.closed");

  if (!closed) {
    return null;
  }

  return (
    <div className="flex items-center gap-2.5 border-b border-orange-100 bg-orange-50 px-4 py-2.5">
      <LockClosedIcon className="size-4 shrink-0 text-orange-600" />
      <p className="text-sm text-orange-800">{t("banner")}</p>
    </div>
  );
}
